import React, {useState} from "react";
import {Container, LoginButton, GuidesList} from "../../styles/Styles";
import AdminNav from "./AdminNav";
import {useQuery} from "@apollo/client";
import {GET_COORDINATORS_LIST} from "../gql/coordinators-gql";
import {InfinitySpin} from "react-loader-spinner";
import AddCoordinatorForm from "../form/AddCoordinatorForm";
import { useAuth } from '../../context/AuthContext';
import { Roles } from '../common/roles';
import { Navigate } from 'react-router-dom';
import styled from "styled-components";

const CoordinatorCard = styled.div`
    background: white;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }

    .coordinator-name {
        font-size: 1.2em;
        font-weight: bold;
        margin-bottom: 10px;
        color: #333;
    }

    .coordinator-email {
        color: #666;
        font-size: 0.9em;
    }
`;

const AdminDashboardCoordinators: React.FC = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const {data, loading, error} = useQuery(GET_COORDINATORS_LIST);
    const { user, isAuthenticated } = useAuth();

    if (loading) return <InfinitySpin />;
    if (error) return <div>Error: {error.message}</div>;

    const coordinators = data?.getCoordinatorsList || [];

    if (!isAuthenticated || user?.role[0] !== Roles.ADMIN) {
        return <Navigate to="/" />;
    }

    return (
        <Container>
            <AdminNav />
            <h2>Coordinators list</h2>
            <LoginButton onClick={() => setShowAddModal(true)}>Add coordinator</LoginButton>
            <GuidesList>
                {coordinators.length === 0
                    ? 'No coordinators yet'
                    : coordinators.map((coordinator: any) => (
                        <CoordinatorCard key={coordinator._id}>
                            <div className="coordinator-name">
                                {coordinator?.profile?.firstName} {coordinator?.profile?.lastName}
                            </div>
                            <div className="coordinator-email">
                                {coordinator?.email}
                            </div>
                        </CoordinatorCard>
                    ))}
            </GuidesList>
            {showAddModal && (
                <AddCoordinatorForm onClose={() => setShowAddModal(false)} />
            )}
        </Container>
    );
};

export default AdminDashboardCoordinators;
